import { render, staticRenderFns } from "./free_users.vue?vue&type=template&id=5ea60074"
import script from "./free_users.vue?vue&type=script&lang=js"
export * from "./free_users.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports